import { type AutocompleteOption } from './types'

export const SELECT_OPTION: AutocompleteOption = {
  value: 'SELECT',
  label: 'Select',
  type: 'button',
}
